import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-history-hospital',
  templateUrl: './history-hospital.component.html',
  styleUrls: ['./history-hospital.component.scss']
})
export class HistoryHospitalComponent implements OnInit {
  //table
  displayedColumns: string[] = ['no', 'date', 'xraydate', 'hospital_number', 'result', 'feedback'];
  dataSource;
  dataSource_summary;
  displayedColumns_summary: string[] = ['no', 'hospital_name', 'packet_name', 'total_film', 'film_upload', 'month', 'year'];
  //form
  formSelect: FormGroup;
  select_hospital = new FormControl('', [Validators.required]);
  months = [
    {
      no_month:"01",
      name_month:"มกราคม",
    },
    {
      no_month:"02",
      name_month:"กุมภาพันธ์",
    },
    {
      no_month:"03",
      name_month:"มีนาคม",
    },
    {
      no_month:"04",
      name_month:"เมษายน",
    },
    {
      no_month:"05",
      name_month:"พฤษภาคม",
    },
    {
      no_month:"06",
      name_month:"มิถุนายน",
    },
    {
      no_month:"07",
      name_month:"กรกฎาคม",
    },
    {
      no_month:"08",
      name_month:"สิงหาคม",
    },
    {
      no_month:"09",
      name_month:"กันยายน",
    },
    {
      no_month:"10",
      name_month:"ตุลาคม",
    },
    {
      no_month:"11",
      name_month:"พฤศจิกายน",
    },
    {
      no_month:"12",
      name_month:"ธันวาคม",
    },
  ]
  years = ['2019','2020']
  hospitals: any = [];
  his_hospitals: any = [];
  data_summary: any
  //variable
  isProcessing: boolean = true;
  showtable: boolean = true;
  show_form_history: boolean = true;
  show_form_summary: boolean = true;
  show_table_summary: boolean = true;

  //API
  hospitalAPI = `${environment.apiUrl}/history/gethospital`;
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    public dialog: MatDialog,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) { 
    this.formSelectHospital()
  }

  ngOnInit() {
    this.getHospital()
  }

  private formSelectHospital() {
    this.formSelect = this.formBuilder.group({
      select_hospital: ['', Validators.required],
      select_month: [[], Validators.required],
      select_year: [[], Validators.required],
    })
  }

  getHospital() {
    this.http.get(this.hospitalAPI, this.httpOptions).subscribe(hospitals => {
      // console.log(hospitals['message']);
      this.hospitals = hospitals['message']
    })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  select_function(value){
    if (value.value == 'his_hospitals') {
      this.show_form_history = false
      this.show_form_summary = true
      // this.showtable = true
    }else if(value.value == 'summary'){
      this.show_form_summary = false
      this.show_form_history = true
      // this.showtable = true
    }
  }

  hospital_select(id) {
    // console.log(id);
    this.isProcessing = false;
    if (id != "All") {
    const url = `${environment.apiUrl}/history/superadmin?hospital_id=${id}`;
    this.http.get(url, this.httpOptions).subscribe(hospitals => {
      console.log(hospitals);
      this.his_hospitals = hospitals
      if (this.his_hospitals.length == 0) {
        this._snackBar.open("No data!", "Done", {
          duration: 10000,
        });
        this.dataSource = new MatTableDataSource(this.his_hospitals)
        this.isProcessing = true
        this.showtable = true
      } else {
        this.dataSource = new MatTableDataSource(this.his_hospitals)
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isProcessing = true;
        this.showtable = false
        this.show_table_summary = true
      }
    })
    } else {
      const url = `${environment.apiUrl}/history/superadmin`;
      this.http.get(url, this.httpOptions).subscribe(hospitals => {
        // console.log(hospitals);
        this.his_hospitals = hospitals
        this.dataSource = new MatTableDataSource(this.his_hospitals)
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isProcessing = true;
      })
    }
  }

  summary(){
    this.isProcessing = false;
    if (this.formSelect.invalid) return;
    // console.log(this.formSelect.value);
    const url = `${environment.apiUrl}/summary?hospital_id=${this.formSelect.value.select_hospital}&month=${this.formSelect.value.select_month}&year=${this.formSelect.value.select_year}`;
    this.http.get(url, this.httpOptions).subscribe(summarys => {
      console.log(summarys);
      this.data_summary = summarys
      if (this.data_summary.message == "No Data") {
        this._snackBar.open(this.data_summary.message, "Done", {
          duration: 10000,
        });
        this.data_summary.message = []
        this.dataSource_summary = new MatTableDataSource(this.data_summary.message)
        this.isProcessing = true;
        this.show_table_summary = false
      } else {
        this.dataSource_summary = new MatTableDataSource(this.data_summary.message)
        this.isProcessing = true;
        this.show_table_summary = false
        this.showtable = true
      }
    }, error =>{
      console.log(error);
      this._snackBar.open("No Data!", "Done", {
        duration: 10000,
      });
      this.isProcessing = true;
    })
  }

}
